module.exports = __webpack_public_path__ + "img/loading2.e7237388.gif";